import { httpRequest } from "../../http.ts";
import { LaunchAdSerializer } from "../../../models/serializers/launchAdSerializer.ts";

/*
    Flip the UTM toggle for one ad on one campaign (MPN-1536).

    Separate from cmdUpdateLaunchAdStatus rather than an extra argument to it: the
    status PATCH runs the whole review transition (todos, actions, Slack alerts), and
    Ops flipping a URL setting must not fire any of that. The server treats the two
    fields independently for the same reason.
*/
export class CommandSetLaunchAdUtm {
  async run(launchAdId: number, appendUtm: boolean) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/launch-ads/${launchAdId}/`;

    const result = await httpRequest<any | null>(url, {
      method: "PATCH",
      body: { append_utm: appendUtm },
    });

    return new LaunchAdSerializer().deserialize(result);
  }
}
